<template>
  <div>
    <loader v-if="loading" :loading="loading"></loader>
    <div class="intro font-md lh-tight wt-sb">
      <div
        class="formatted terms-and-conditions"
        v-html="terms_and_conditions"
      ></div>
    </div>
    <div class="modal-actions">
      <div class="action">
        <button type="button" class="button primary" @click="confirmAction">
          <span>Close Window</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import BaseModal from "../Base";

// TODO loader

export default {
  extends: BaseModal,
  mounted() {
    this.loading = true;
    axios.get("/api/form-meta/terms-and-conditions").then((response) => {
      this.terms_and_conditions = response.data.privacy || null;
      this.loading = false;
    });
  },
  data() {
    return {
      terms_and_conditions: null,
    };
  },
};
</script>
